import { Col, Row } from 'react-bootstrap';
import React from 'react';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { CgDatabase } from 'react-icons/cg';
import './hero.css'

import { MdHelpCenter } from "react-icons/md";
import { FaBook } from "react-icons/fa";

import manualPDF from '../../doc/Toxifinder_Manual_Usuario.pdf'

export default function Hero2() {

    const pdfUrl = process.env.PUBLIC_URL + '/public/Toxifinder_Manual_Usuario.pdf';

    return <div >
        <Row className='d-flex justify-content-center mx-auto Row2'>
            <Col xs={10} md={4} className='d-flex align-items-center flex-column text-center medicineCol'>
                <CgDatabase style={{ fontSize: '70px', color: '#28242c' }} />
                <h3 className='py-1'>Base de datos</h3>
                <p>
                    Nuestra base de datos de tóxicos está constantemente siendo actualizada. Actualmente contamos con el 10% de los casos más recurrentes.
                </p>
            </Col>
            <Col xs={10} md={2} className='d-flex align-items-center flex-column text-center medicineCol'>
                <FaBook style={{ fontSize: '65px', color: '#28242c' }} />
                <h3 className='py-1'>Manual</h3>
                <p>
                    Acceder al manual para obtener más detalles sobre el uso de Web App Toxifinder&nbsp;
                    <a href={manualPDF} target="_blank" rel="noopener noreferrer" title="Abrir Manual">
                        <FaBook style={{fontSize:'30px', color: '#28242c' }} />
                    </a>
                </p>
            </Col>
            <Col xs={10} md={4} className='d-flex align-items-center flex-column text-center medicineCol '>
                <BsFillCheckCircleFill style={{ fontSize: '70px', color: '#28242c' }} />
                <h3 className='py-1'>Oficialidad</h3>
                <p>
                    Toda la información subida es de carácter oficial y ha sido previamente validada por expertos.
                </p>
            </Col>

        </Row>
        <div style={{marginBottom:'5%'}}></div>
  </div>;
}

